import { ReactComponent as Profile } from "../assets/SVG/services/profile.svg";

type ProfileData = {
  id: number;
  name: string;
  image: JSX.Element;
  location: string;
  time: string;
  firm: string;
  price: string;
};
// profile data
export const Profiles: ProfileData[] = [
  {
    id: 0,
    name: "Jessica Pearson",
    image: <Profile />,
    location: "193-197 Edward Pl, London SE8 5HD, United Kingdom",
    time: "8.00 am to 5.00 pm Monday to Friday",
    firm: "Pearson Spectre Law Firm",
    price: "£25.00",
  },
  {
    id: 1,
    name: "Pearson",
    image: <Profile />,
    location: "2-6 Lamb Ln, London E8 3PL, United Kingdom",
    time: "8.00 am to 5.00 pm Monday to Friday",
    firm: "Pearson Spectre Law Firm",
    price: "£25.00",
  },
  {
    id: 2,
    name: "Pearson Jessica",
    image: <Profile />,
    location: "21 Barretts Green Rd, London NW10 7AE, United Kingdom",
    time: "8.00 am to 5.00 pm Monday to Friday",
    firm: "Pearson Spectre Law Firm",
    price: "£25.00",
  },
  {
    id: 3,
    name: "Newton",
    image: <Profile />,
    location: "193-197 Edward Pl, London SE8 5HD, United Kingdom",
    time: "8.00 am to 5.00 pm Monday to Friday",
    firm: "Pearson Spectre Law Firm",
    price: "£20.00",
  },
  {
    id: 4,
    name: "Einstein",
    image: <Profile />,
    location: "193-197 Edward Pl, London SE8 5HD, United Kingdom",
    time: "8.00 am to 5.00 pm Monday to Friday",
    firm: "Pearson Spectre Law Firm",
    price: "£10.00",
  },
  {
    id: 5,
    name: "Syed Mohsin",
    image: <Profile />,
    location: "193-197 Edward Pl, London SE8 5HD, United Kingdom",
    time: "8.00 am to 5.00 pm Monday to Friday",
    firm: "Pearson Spectre Law Firm",
    price: "£15.00",
  },
  {
    id: 6,
    name: "New Data",
    image: <Profile />,
    location: "Leeds, West Yorkshire (0113)",
    time: "8.00 am to 5.00 pm Monday to Friday",
    firm: "Pearson Spectre Law Firm",
    price: "£15.00",
  },
];
type Options = {
  location: string;
};
export const SearchOptions: Options[] = [
  { location: "Leeds, West Yorkshire (0113)" },
  { location: "Brougham Street, Zone 4, Edinburgh (12002)" },
  { location: "Nottingham, 0115" },
];
type SelectOptions = {
  id: number;
  name: string;
};

type MilesType = {
  id: number;
  name: string;
  value:string;
};
export const SelectData: SelectOptions[] = [
  {
    id: 0,
    name: "Lawyers",
  },
  {
    id: 1,
    name: "Charging Stations",
  },
  {
    id: 2,
    name: "Insurance Companies",
  },
  {
    id: 3,
    name: "MOT Centres",
  },
  {
    id: 4,
    name: "Motor Dealers",
  },
  {
    id: 5,
    name: "Motor Auctioneers",
  },
  {
    id: 6,
    name: "Salvage Dealers",
  },

  {
    id: 7,
    name: "Finance Companies",
  },
  {
    id: 8,
    name: "Fleet Operators",
  },
  {
    id: 9,
    name: "Car Buying Services",
  },
];

export const Miles: MilesType[] = [
  { id: 0, name: "Overall", value:"10" },
  { id: 1, name: "within 0.5 mile", value:"0.5" },
  { id: 2, name: "within 1.5 mile", value:"1.5" },
  { id: 3, name: "within 2.5 mile", value:"2.5" },
  { id: 4, name: "within 3.5 mile", value:"3.5" },
  { id: 5, name: "within 4.5 mile", value:"4.5" },
  { id: 6, name: "within 5 mile" , value:"5"},
];

